@if (htmlDescription()) {
  <div class="item-description ck-content"
       [class.full-body]="fullBody()"
       [innerHtml]="htmlDescription() | relativeLinks | safeHtml"></div>
}
